import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { getPlantData, getClimateData } from "../../store/design/actions"
import ReactApexChart from "react-apexcharts"
import { getAreas, updateArea, deleteArea, addArea } from "../../store/goals/actions"
import moment from 'moment';
import classnames from "classnames"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid';
import Editable from 'react-x-editable'
import DatePicker from "react-datepicker"
import Spreadsheet from "react-spreadsheet";
import { useDrag, useDrop } from "react-dnd";
import {
  Badge,
  Col,
  Collapse,
  CardHeader,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
  Dropdown,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  TabContent,
  TabPane,
  Input,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"
import { Image } from '@aws-amplify/ui-react';
import { Storage } from '@aws-amplify/storage'

const type = "Family";

const Family = props => {
  const { plantMap, areaIndex, summer, fall, spring, winter, family, familyStyle, deletePlant, updateSpaceUsed, areas, setAreas, userareas, onUpdateArea } = props
  
  const [currPlant, setCurrPlant] = useState({})
  const [species, setSpecies] = useState()
  const [variety, setVariety] = useState()
  const [name, setName] = useState()
  const [space, setTotalSpace] = useState()

  return (
 <Card color={familyStyle}>
                <CardBody style={{margin:"5px", padding:"2px", border:"2px"}}>
                  <CardTitle className="mb-4 text-white">
                    {family} 
                  </CardTitle>
{areas[areaIndex].plants.filter(plant => {

    if (plant.plant_family==family) {
     if (summer[areaIndex] && plant.season_rotation=="Summer") {
        return plant;
    } else if (spring[areaIndex] && plant.season_rotation=="Spring") {
        return plant;
    } else if (fall[areaIndex] && plant.season_rotation=="Fall") {
        return plant;
    } else if (winter[areaIndex] && plant.season_rotation=="Winter") {
        return plant;
    }
    if (!summer[areaIndex] && !spring[areaIndex] && !fall[areaIndex] && !winter[areaIndex])
         return plant;
   }
}).map((plant, pindex) => (
        <Card outline style={{marginTop:"5px", marginBottom: "0px", padding:"2px", border:"2px"}} className="border">
    <CardBody  style={{marginTop:"0px", marginBottom: "0px", padding:"2px", border:"2px"}} >
        <Row>
            <Col md={12}><Image className="img-fluid" style={{"--width": "100%", "--height":"100%"}} src={"/"+plant.species.toLowerCase().replace(" ","_")+".png"} />
            </Col>
        </Row>
        <Row>
            <Col md={12} style={{fontSize:".9em"}}>{plant.species}</Col>
        </Row>
         <Row>
            <Col md={12} style={{fontSize:".9em"}}><i>{plant.variety}</i></Col>
        </Row>
     </CardBody>
  </Card>

))}

     </CardBody>
  </Card>

   );
}
export default Family;
